import { getOrderDeliveryAddress } from '@/entities/order';
import type { OrderDto } from '@/shared/api/order';
import { CheckoutCharacteristic } from '../CheckoutCharacteristic';

interface AddressInfoProps {
    order: OrderDto;
}

export const AddressInfo = ({ order }: AddressInfoProps) => {
    switch (order.delivery.method) {
        case 'COURIER': {
            return (
                <>
                    <CheckoutCharacteristic title="Адрес доставки" content={getOrderDeliveryAddress(order)} />
                    {order.delivery.delivery_notes && (
                        <CheckoutCharacteristic
                            title="Комментарий для курьера"
                            content={order.delivery.delivery_notes}
                        />
                    )}
                </>
            );
        }
        case 'PICKUP_POINT': {
            return <CheckoutCharacteristic title="Адрес ПВЗ" content={getOrderDeliveryAddress(order)} />;
        }
        case 'SELF_PICK_UP': {
            return <CheckoutCharacteristic title="Адрес для самовывоза" content={getOrderDeliveryAddress(order)} />;
        }

        default: {
            return null;
        }
    }
};
